module.exports = __webpack_public_path__ + "static/media/desktop4.65f42099.png";